import { render, staticRenderFns } from "./SerializedInventory.vue?vue&type=template&id=3abf725c&scoped=true"
import script from "./SerializedInventory.vue?vue&type=script&lang=js"
export * from "./SerializedInventory.vue?vue&type=script&lang=js"
import style0 from "./SerializedInventory.vue?vue&type=style&index=0&id=3abf725c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf725c",
  null
  
)

export default component.exports